import { render } from "./DeactivatedAccounts.vue?vue&type=template&id=38305055"
import script from "./DeactivatedAccounts.vue?vue&type=script&lang=js"
export * from "./DeactivatedAccounts.vue?vue&type=script&lang=js"

import "./DeactivatedAccounts.vue?vue&type=style&index=0&id=38305055&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__